var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-plus-minus"},[_c('SvgIcon',{attrs:{"name":"minus"}}),_c('SvgIcon',{class:_vm.active ? 'active' : '',attrs:{"name":"minus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }